import { useQuery } from '@tanstack/react-query'
import type { KambiSportsSelection } from '@mobi/betslip/types'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { createKambiBetRequest } from '@core/Areas/Quickbet/helpers/betting/kambiSports/utils/createBetRequest'
import { postValidateKambiSportsBet } from '@core/Areas/KambiSports/helpers/api/betting'

export const useGetKambiRewardsForSelection = (selection: KambiSportsSelection) => {
  const { data, isError } = useQuery({
    queryKey: queryKeys.kambiPlayerRewards,
    queryFn: () =>
      postValidateKambiSportsBet(createKambiBetRequest({ selection, investmentWin: 1 })),
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  })

  if (isError || !data) return null

  return data.rewardInfo
}
